/**
 * Consume AbilitySpec castTime / effectDelay / duration on a caster entity.
 */

function num(value) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

export function queueCastWindup(entity, payload = {}) {
  if (!entity) return null;
  entity.pendingCast = {
    ...payload,
    remainingCast: num(payload.castTime),
    remainingDelay: num(payload.effectDelay),
    duration: num(payload.duration)
  };
  return entity.pendingCast;
}

function tickEffectDuration(entity, dt) {
  if (!(entity.abilityEffectDuration > 0)) return;
  entity.abilityEffectDuration = Math.max(0, entity.abilityEffectDuration - dt);
}

export function tickCastWindup(entity, dt = 0) {
  if (!entity) return null;
  tickEffectDuration(entity, dt);
  const pending = entity.pendingCast;
  if (!pending) return null;
  let left = dt;
  if (pending.remainingCast > 0) {
    const used = Math.min(left, pending.remainingCast);
    pending.remainingCast -= used;
    left -= used;
  }
  if (pending.remainingCast > 0) return null;
  if (pending.remainingDelay > 0) {
    const used = Math.min(left, pending.remainingDelay);
    pending.remainingDelay -= used;
    left -= used;
  }
  if (pending.remainingDelay > 0) return null;
  entity.pendingCast = null;
  if (pending.duration > 0) {
    entity.abilityEffectDuration = pending.duration;
  }
  return pending;
}
